import { useEffect, useRef, useState } from "react";
import { API_BASE } from "../lib/api";

export default function BookReader({ manifest, onClose }) {
  const { count, width, height, updated_at } = manifest;
  const [spread, setSpread] = useState(0);
  const [ready, setReady] = useState(false);
  const [showHint, setShowHint] = useState(false);
  const lastWheel = useRef(0);

  const url = (n) => `${API_BASE}/photos/${n}?v=${encodeURIComponent(updated_at || "")}`;

  useEffect(() => {
    let first = false;
    for (let n = 1; n <= count; n++) {
      const im = new Image();
      im.src = url(n);
      im.onload = im.onerror = () => {
        if (!first) {
          first = true;
          setReady(true);
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const turn = (d) => setSpread((s) => Math.min(count - 1, Math.max(0, s + d)));
    const onWheel = (e) => {
      e.preventDefault();
      const now = Date.now();
      if (now - lastWheel.current < 300 || Math.abs(e.deltaY) < 8) return;
      lastWheel.current = now;
      turn(e.deltaY > 0 ? 1 : -1);
    };
    const onKey = (e) => {
      if (e.key === "ArrowRight") turn(1);
      else if (e.key === "ArrowLeft") turn(-1);
      else if (e.key === "Escape") onClose();
    };
    const onFsChange = () => {
      if (!document.fullscreenElement) onClose();
    };
    window.addEventListener("wheel", onWheel, { passive: false });
    window.addEventListener("keydown", onKey);
    document.addEventListener("fullscreenchange", onFsChange);
    if (window.__lenis) window.__lenis.stop();
    return () => {
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("keydown", onKey);
      document.removeEventListener("fullscreenchange", onFsChange);
      if (window.__lenis) window.__lenis.start();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!ready) return;
    setShowHint(true);
    const t = setTimeout(() => setShowHint(false), 4000);
    return () => clearTimeout(t);
  }, [ready]);

  return (
    <div data-testid="book-reader" className="fixed inset-0 z-50 flex items-center justify-center bg-[#202020]">
      {!ready && (
        <p data-testid="book-loading" className="font-sans text-[11px] uppercase tracking-[0.3em] text-[#6E6B63]">
          Opening the book
        </p>
      )}
      {ready && (
        <img
          key={spread}
          data-testid="book-spread"
          src={url(spread + 1)}
          alt={`Pages ${spread * 2 + 1}–${Math.min(spread * 2 + 2, count * 2)}`}
          width={width}
          height={height}
          draggable={false}
          className="reader-pair max-w-none select-none"
          style={{ width, height }}
        />
      )}
      <p
        data-testid="book-hint"
        className={`pointer-events-none fixed inset-x-0 bottom-10 text-center font-sans text-xs tracking-[0.08em] text-[#A39E93] transition-opacity duration-700 ${showHint ? "opacity-100" : "opacity-0"}`}
      >
        Use mouse wheel and arrow keys to turn pages. Use escape key to close the book.
      </p>
    </div>
  );
}
